import React from "react";
import "./index.m.css";
import { FailureIconInner, FailureCircleOuter, FailureCircleMiddle, RetryIcon } from "./icons";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import { SpinnerLoader } from "../../../common/loader";

export const FailurePage = ({ onRetry, onReview, onReturnHome, isPaying }) => {
  return (
    <div styleName="failurePageContainer">
      {isPaying && (
        <div styleName="overlayLoader">
          <SpinnerLoader />
        </div>
      )}
      <div styleName="contentArea">
        <div styleName="clipWrapper">
          <div styleName="ringsBackground">
            <FailureCircleOuter styleName="outerCircle" />
            <FailureCircleMiddle styleName="middleCircle" />
          </div>
        </div>

        <div styleName="contentWrapper">
          <FailureIconInner styleName="innerIcon" />
          <h1 styleName="title">{SUBSCRIBE_PAGE_TEXT.FAILURE_TITLE}</h1>
          <p styleName="message">
            {SUBSCRIBE_PAGE_TEXT.FAILURE_MSG}
          </p>

          <div styleName="buttonGroup">
            <button styleName="primaryButton" onClick={onRetry} disabled={isPaying}>
              <RetryIcon styleName="buttonIcon" />
              {SUBSCRIBE_PAGE_TEXT.RETRY_CTA}
            </button>
            <button styleName="secondaryButton" onClick={onReview}>
              {SUBSCRIBE_PAGE_TEXT.REVIEW_CTA}
            </button>
          </div>

          <button styleName="returnLink" onClick={onReturnHome || (() => { if (typeof window !== "undefined") window.location.href = "/"; })}>
            {SUBSCRIBE_PAGE_TEXT.RETURN_LINK}
          </button>

          <div styleName="contactSection">
            <div styleName="contactHeader">
              <span styleName="contactTextRegular">{SUBSCRIBE_PAGE_TEXT.CONTACT_PREFIX}</span>
              <span styleName="contactTextBold">{SUBSCRIBE_PAGE_TEXT.CONTACT_SUFFIX}</span>
            </div>

            <a href={SUBSCRIBE_PAGE_TEXT.WHATSAPP_LINK} styleName="contactButton whatsappBtn" target="_blank" rel="noopener noreferrer">
              <Whatsapp width={18} height={18} color="#25D366" />
              <span>{SUBSCRIBE_PAGE_TEXT.WHATSAPP_NUMBER}</span>
            </a>

            <a href={SUBSCRIBE_PAGE_TEXT.EMAIL_LINK} styleName="contactButton mailBtn" target="_blank" rel="noopener noreferrer">
              <Mail width={16} height={13} color="#999" />
              <span>{SUBSCRIBE_PAGE_TEXT.EMAIL_ID}</span>
            </a>

            <div styleName="timingTitle">{SUBSCRIBE_PAGE_TEXT.TIMING_TITLE}</div>
            <div styleName="timingText">{SUBSCRIBE_PAGE_TEXT.TIMING_TEXT}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
